import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_PUBLIC_SENTRY_DSN;
const environment =
  import.meta.env.VITE_PUBLIC_SENTRY_ENVIRONMENT ?? import.meta.env.MODE;

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: 1.0,

    integrations: [Sentry.replayIntegration()],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
